define('responsive-gameday/controllers/MatchupViewController',['require','exports','module','Responsive/controllers/ViewController','../views/render/MatchupViewRender','Responsive/util/renderComplete','../views/Monitor/Events/ViewModelUpdateEvents','message-service/message-service'],function(require,exports,module) {
    // Add private variables here
    var ViewController = require("Responsive/controllers/ViewController"),
        MatchupViewRender = require( '../views/render/MatchupViewRender' ),
        renderComplete = require("Responsive/util/renderComplete"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service");
    var Superclass,
        renderers = null;

    function onBeat(payload, evt) {
        var view = this.view,
            self = this;

        if (!payload || !this.isViewLoaded()) {
            return;
        }

        view.innerHTML = this.viewRender.render(payload);
    };

    // Constructor
    function MatchupViewController(showTeamMatchup) {
        // Call super constructor
        Superclass.constructor.call(this);
        this.referenceName = "matchup";
        this.viewRender = new MatchupViewRender(showTeamMatchup);

        MessageService.publish("registerViewComponent", this);
        this.onBeat=function(payload, evt) {
            onBeat.call(this,payload,evt);
        };

    }

    // Prototype Inheritence
    ViewController.spawn(MatchupViewController).define({
        loadView: function () {
            Superclass.loadView.call(this);
            this.setClassName("MatchupViewController");
        },

        viewDidAppear: function () {
            var that = this;
            Superclass.viewDidAppear.call(that);
            MessageService.addListener.call(that, VMEvents.UPDATE_MATCHUP, that.onBeat);
            MessageService.publish(VMEvents.REQUEST_MATCHUP_DATA);
        },

        viewWillDisappear: function () {
            var that = this;
            Superclass.viewWillDisappear.call(that);
            MessageService.removeListener.call(that, VMEvents.UPDATE_MATCHUP, this.onBeat);
        }
    });

	Superclass = MatchupViewController.superclass;

    return MatchupViewController;
});
